import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { genericMapUtils } from '../services/generic-map-utils';
import { LayerDefinition } from './layer-type';
import { IMapFiltrableProperties } from './map-filtrable-properties';
import { MapGenericStyle } from './map-generic-style';
import { ILayerProviderSettings } from './map-provider-settings';
import { NativeLayer } from './native-layer';

export class LayerItemV2 {
  layerId; // ne-type+scenario
  layerKey: string;
  layerName: string;
  pane: string;
  paneIndex: number; // zIndex of the pane
  layerDefinition: LayerDefinition; // -> popula en MapStyleService
  layerProvider: ILayerProviderSettings; //(GeoServerProviderSettings) -> entra propulado
  originalFiltrableProperties: IMapFiltrableProperties; // -> entra propulado;
  currentFiltrableProperties?: IMapFiltrableProperties;
  iconPath?: string;

  /**
   * Fields that are populated internally.
   */

  isVisible: boolean = true; // -> popula en MapService
  filters?: CompositeFilterDescriptor; // -> popula en MapService
  availableStyles?: MapGenericStyle[];
  layerStyle?: MapGenericStyle;
  nativeLayer?: NativeLayer; //-> popula en MapLayerService (layer.service.ts)

  constructor(init: {
    layerId;
    layerName: string;
    pane: string;
    paneIndex: number;
    layerDefinition: LayerDefinition;
    layerProvider: ILayerProviderSettings;
    filtrableProperties: IMapFiltrableProperties;
    layerStyle: MapGenericStyle;
    iconPath?: string;
    availableStyles?: MapGenericStyle[];
  }) {
    Object.assign(this, init);
    this.originalFiltrableProperties = init?.filtrableProperties;
    this.layerKey = this.layerStyle.isThematic
      ? genericMapUtils.getThematicId(this.layerName, this.layerStyle?.id)
      : this.layerName;
  }
}
